import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import i18n from './i18n';

import SproutDesignSystem from 'design-system-next';
import FloatingVue from 'floating-vue';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { plugin } from '@formkit/vue';
import config from '../formkit.config';

import 'design-system-next/style.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(plugin, config);
app.use(SproutDesignSystem);
app.use(VueDOMPurifyHTML);

app.use(FloatingVue, {
  themes: {
    'spa-tooltip': {
      $extend: 'tooltip',
      triggers: ['click'],
      autoHide: true,
    },
    'job-request-tooltip': {
      $extend: 'dropdown',
      placement: 'bottom',
      triggers: ['hover'],
    },
    'default-dropdown': {
      $extend: 'dropdown',
      triggers: ['click'],
      popperTriggers: ['click'],
      delay: {
        show: 0,
        hide: 100,
      },
    },
  },
});

app.mount('#app');
